module.exports = __webpack_public_path__ + "img/mickey118.7731e874.jpg";